module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "duration": "2000"
    }
  }, [(_vm.active) ? _c('div', {
    staticClass: "loader"
  }, [_c('span', {
    staticClass: "loader__text"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('span', {
    staticClass: "loader__spinner"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0691caac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 275
// module chunks = 0